import { CubeTimeDimensionGranularity } from '../../../../common/enum/cube-time-dimension-granularity.enum';
import { CubeRequestConfig } from '../../../../common/interface/cube-request-config.interface';
import { SharedOrgMetricsRequestDto } from '../../common/shared-org-metrics-request.dto';

export interface GetAccountAverageWorkingHoursSummaryRequestDto {
  params: {
    startDate: string;
    granularity: CubeTimeDimensionGranularity;
    aggregateGranularity?: CubeTimeDimensionGranularity;
  } & SharedOrgMetricsRequestDto;
  config: CubeRequestConfig;
}
